<script setup>
import { ref, onBeforeUnmount, useSlots } from 'vue';
import { showTooltip, hideTooltip } from './tooltipState.js';

const props = defineProps({
    alignment: {
        type: String,
        default: 'left',
        validator: (v) => ['left', 'center', 'right'].includes(v),
    },
    verticalAlignment: {
        type: String,
        default: 'top',
        validator: (v) => ['top', 'center', 'bottom'].includes(v),
    },
    tooltipClass: {
        type: String,
        default: '',
    },
    additionalTooltipClass: {
        type: String,
        default: '',
    },
    offset: {
        type: Number,
        default: 0,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const triggerRef = ref(null);
const slots = useSlots();

function show() {
    if (props.disabled || !triggerRef.value) return;
    showTooltip({
        triggerEl: triggerRef.value,
        render: slots.tooltip ? () => slots.tooltip() : null,
        alignment: props.alignment,
        verticalAlignment: props.verticalAlignment,
        offset: props.offset,
        tooltipClass: props.tooltipClass,
        additionalTooltipClass: props.additionalTooltipClass,
    });
}

function hide() {
    if (triggerRef.value) hideTooltip(triggerRef.value);
}

function onFocusOut(event) {
    if (triggerRef.value && triggerRef.value.contains(event.relatedTarget)) return;
    hide();
}

onBeforeUnmount(hide);
</script>

<template>
    <span
        ref="triggerRef"
        @mouseenter="show"
        @mouseleave="hide"
        @focusin="show"
        @focusout="onFocusOut"
    >
        <slot />
    </span>
</template>
